import { StMultyPropertyTypes } from "@/types";
import { useData } from "../useData";
import { stMultyUnitPropertyTypesRepository } from "@/repositories/StMultyUnitPropertyTypesRepo";
import { MultiLanguageString } from "@/lib/api/stays/types/shared-types";

interface IStMultyUnitPropertyTypes {
  _mstitle: MultiLanguageString;
  id: string;
  stays_id: string;
}

export const useStaysMultyUnitPropertyTypes = () => {
  const {
    data: stMultyUnitPropertyTypes,
    isLoading,
    error,
    refetch,
  } = useData<StMultyPropertyTypes>({
    repository: stMultyUnitPropertyTypesRepository,
    fetcher: (repo) => repo.getAll(),
    queryKey: ["st_multy_unit_property_types"],
  });

  return {
    stMultyUnitPropertyTypes: (stMultyUnitPropertyTypes ??
      []) as IStMultyUnitPropertyTypes[],
    isLoading,
    error,
    refetch,
  };
};
